import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { UIService } from '~/services/service.ui';
import { Column, Row } from '~/views/atoms/boxes';
import { BottomNav } from '~/views/molecules/nav.bottom';
import { useService } from '~/services/service.base';
import { ServiceCommunity } from '~/services/service.community';
import { AuthService } from '~/services/service.auth';
export const FundsWrapper = () => {
    const communityService = useService(ServiceCommunity);
    const authService = useService(AuthService);
    useEffect(() => {
        if (!communityService) {
            return;
        }
        communityService.getCommunity(17, !authService.isLogged);
    }, [authService.isLogged, communityService]);
    return (_jsxs(Column, { flex: 1, children: [_jsx(Column, { flex: 1, children: _jsx(Outlet, {}) }), _jsx(Row, { minHeight: UIService.BOTTOMBAR_HEIGHT }), _jsx(BottomNav, {})] }));
};
